import router from './router/actions'
import modals from './modals/actions'
import ui from './ui/actions'
import me from './me/actions'
import cookies from './cookies/actions'

import news from './news/actions'
import heroes from './heroes/actions'
import voting from './voting/actions'
import marketplace from './marketplace/actions'
import lscSchedules from './lsc-schedules/actions'
import lscTransportControl from './lsc-transportControl/actions'
import emergencyAlert from './emergency-alert/actions'


export default {
  news,
  heroes,
  voting,
  marketplace,
  lscSchedules,
  lscTransportControl,
  emergencyAlert,

  router,
  modals,
  ui,
  me,
  cookies,
}
